// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Caml_array from "../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as LocationBoundApiModel from "../api-model/LocationBoundApiModel.bs.js";

function getPickupDropPolygon(polygon) {
  return $$Array.map((function (e) {
                return $$Array.map((function (v) {
                              return {
                                      lat: Caml_array.get(v, 1),
                                      lng: Caml_array.get(v, 0)
                                    };
                            }), e);
              }), polygon);
}

function apiModelToEntity(data) {
  return {
          pickup_polygon: getPickupDropPolygon(data.geo_region.pickup_polygon),
          drop_polygon: getPickupDropPolygon(data.geo_region.drop_polygon)
        };
}

function execute(json) {
  return apiModelToEntity(DeccoUtils$Catalyst.resolveResult(LocationBoundApiModel.t_decode(json), "LocationBoundEntityMapper.res"));
}

export {
  getPickupDropPolygon ,
  apiModelToEntity ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
